import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function SettingsNavigation({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Sezioni Impostazioni" className="mb-5 flex flex-wrap gap-2 pb-1">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          data-testid={item.testid}
          className={({ isActive }) => (
            `inline-flex min-h-9 shrink-0 items-center gap-1.5 rounded-full border px-3 py-2 text-xs font-semibold transition-colors ${
              isActive
                ? 'border-emerald-200 bg-emerald-50 text-brand-green-hover'
                : 'border-stone-200 bg-white text-stone-600 hover:border-stone-300 hover:text-stone-900'
            }`
          )}
        >
          {item.icon && <item.icon className="h-3.5 w-3.5" aria-hidden="true" />}
          {item.label}
          <ChevronRight className="h-3.5 w-3.5 text-stone-300" aria-hidden="true" />
        </NavLink>
      ))}
    </nav>
  );
}